import { render } from "./Figure2.vue?vue&type=template&id=53dc5a1c&bindings={}"
import script from "./Figure2.vue?vue&type=script&lang=ts"
export * from "./Figure2.vue?vue&type=script&lang=ts"
script.render = render

export default script